import type { TranslationKey } from "$lib/i18n";

export abstract class EditorModelBase {
  abstract validate(): [boolean, TranslationKey | ''];

  private _validation = $derived.by(() => this.validate());
  isValid = $derived.by(() => this._validation[0]);
  error = $derived.by((): TranslationKey | '' => this._validation[1]);
  showError = $derived.by(() => !this.isValid);
}
